import type { Species } from "@/types";
import { BackIcon } from "@/app/components/system/Icons";

type KnownSpeciesCardSpecies =
  & Pick<Species, "scientific" | "color" | "initial" | "labelImageUrl">
  & { common: string | null };

interface KnownSpeciesCardProps {
  species: KnownSpeciesCardSpecies;
  onClick: () => void;
}

export function KnownSpeciesCard({ species: s, onClick }: KnownSpeciesCardProps) {
  const title = s.common || s.scientific;
  const subtitle = s.common && s.scientific && s.common !== s.scientific ? s.scientific : "";
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full flex items-center gap-3.5 p-4.5 bg-paper border border-line rounded-[18px] cursor-pointer text-left transition-all duration-150 text-ink hover:border-moss-2 hover:-translate-y-px active:scale-[0.99]"
    >
      <span
        className="w-13 h-13 rounded-2xl overflow-hidden grid place-items-center shrink-0 text-paper [&>img]:w-full [&>img]:h-full [&>img]:block [&>img]:object-cover"
        style={{ background: s.color }}
      >
        {s.labelImageUrl
          ? <img src={s.labelImageUrl} alt="" />
          : <span className="font-display font-medium text-[22px]">{s.initial || "?"}</span>}
      </span>
      <span className="flex-1 flex flex-col gap-0.5 min-w-0">
        <strong className="text-base font-medium whitespace-nowrap overflow-hidden text-ellipsis">{title}</strong>
        {subtitle && (
          <em className="italic text-[12.5px] text-ink-3 opacity-75 leading-[1.4] whitespace-nowrap overflow-hidden text-ellipsis">
            {subtitle}
          </em>
        )}
      </span>
      <BackIcon size={18} />
    </button>
  );
}
